module.exports = __webpack_public_path__ + "static/img/logo11.8ae90d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo11.jpg
// module id = hPA4
// module chunks = 2